<div class="header">
  <img src="assets/logo.png" class="logo">
</div>
<div class="maintenance">
  現在メンテナンス中です。
  <br />
  <br />
  <span class="footer">UNION NEST</span>
</div>
